<input [(ngModel)]="value" name="value" value="{{value}}" type="input" (blur)="saveValue()" style="width: 85px; text-align: center;">

